import TrackedButton from "./TrackedButton";
import { Lightbulb, BarChart2, Rocket, CheckCircle } from "lucide-react";
import bgImage from "../assets/images/multiturbine8A.jpg";


const tiers = [
  {
    icon: Lightbulb,
    tier: "Tier 1",
    name: "Signal Scan",
    label: "Discover",
    description: "For businesses unsure what’s working—or what’s even tracking.",
    bullets: [
      "GA4 + Search Console Check",
      "Social & referral traffic scan",
      "Mini CX audit",
      "Source Map PDF + Strategy Call"
    ],
    frequency: "One-time audit",
    bestFor: "Early-stage teams or site handoffs",
    eventLabel: "Homepage - View Tier 1",
    price: "$999",
    priceNote: "one-time"
  },
  {
    icon: BarChart2,
    tier: "Tier 2",
    name: "Unified Source Map",
    label: "Align",
    description: "Get your marketing, analytics, and CX finally working together.",
    bullets: [
      "Everything in Tier 1",
      "Scribbyl Central dashboard setup",
      "Light implementation support",
      "Quarterly review with the team"
    ],
    frequency: "3 month minimum",
    bestFor: "Founders actively marketing but flying blind",
    eventLabel: "Homepage - View Tier 2",
    price: "$1,999",
    priceNote: "per month"
  },
  {
    icon: Rocket,
    tier: "Tier 3",
    name: "Growth Ops Partner",
    label: "Grow",
    description: "Plug us in as your fractional growth team—CX, content, and conversion all aligned.",
    bullets: [
      "Everything in Tier 2",
      "SEO, content, and analytics strategy",
      "15 hours of Upgrades per month",
      "Monthly review with the team"
    ],
    frequency: "6 month minimum",
    bestFor: "Scaling brands & CX-led founders",
    eventLabel: "Homepage - View Tier 3",
    price: "$3,999",
    priceNote: "per month"
  }
];

export default function ServiceTiersExpanded() {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  return (
    <section id="tiers" className="relative text-white py-16 px-4 md:px-10 overflow-hidden">
  {/* Background Image */}
  <img
    src={bgImage}
    alt="Background"
    className="absolute inset-0 w-full h-full object-cover z-0"
  />

  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/60 z-0" />

  {/* Foreground Content */}
  <div className="relative z-10 max-w-7xl mx-auto text-center">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold mb-3">
          Choose Your Growth Plan
        </h2>
        <p className="text-base text-white/70 mb-12">
          Each tier builds on the last—start with clarity, scale with confidence.
        </p>

        <div className="grid gap-10 md:grid-cols-3">
          {tiers.map((tier, index) => (
            <div
              key={index}
              className="relative rounded-2xl border border-white/10 backdrop-blur-lg bg-white/20 shadow-lg p-6 flex flex-col justify-between text-left"
            >
              {/* Price Ribbon */}
              <div className="absolute top-0 right-0 bg-strobe-red text-white text-sm font-semibold px-4 py-2 rounded-bl-md shadow-md z-10">
                {tier.price}{" "}
                <span className="text-white/70 text-xs font-normal">
                  ({tier.priceNote})
                </span>
              </div>

              <div className="flex flex-col flex-grow">
                {/* Header */}
                <div className="text-center mb-4 mt-8">
                  <span className="text-xs uppercase font-bold tracking-wide text-white/70 block mb-1">
                    {tier.tier}
                  </span>
                  <tier.icon className="w-10 h-10 text-white mx-auto mb-2" />
                  <h3 className="text-lg font-heading font-semibold mb-1">
                    {tier.label}
                  </h3>
                  <p className="text-sm text-white/80 font-body mb-4">
                    {tier.description}
                  </p>
                </div>

                {/* Bullet List */}
                <ul className="text-sm text-white mb-4 space-y-2">
                  {tier.bullets.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <CheckCircle className="w-4 h-4 text-strobe-red mt-1" />
                      {item}
                    </li>
                  ))}
                </ul>

                <hr className="border-t border-white/10 my-4" />

                {/* Frequency and Target */}
                <div className="text-sm font-semibold text-white/70 mb-1 italic border-l-4 pl-3 border-white/30">
                  {tier.frequency}
                </div>
                <div className="text-sm font-medium text-white">
                  Best for: {tier.bestFor}
                </div>
              </div>

              {/* CTA */}
              <div className="mt-6">
                {isMobile ? (
                  <a
                    href="tel:+18444727422"
                    onClick={() => window?.gtag?.("event", "click", { event_label: tier.eventLabel })}
                    className="inline-block w-full bg-white/10 text-white text-sm font-semibold px-5 py-3 rounded-full hover:bg-white/20 border border-white/30 transition text-center backdrop-blur-md"
                  >
                    Book a Discovery Call ↗
                  </a>
                ) : (
                  <TrackedButton
                    to="/contact"
                    eventLabel={tier.eventLabel}
                    className="inline-block w-full bg-white/10 text-white text-sm font-semibold px-5 py-3 rounded-full hover:bg-white/20 border border-white/30 transition text-center backdrop-blur-md"
                  >
                    Book a Discovery Call ↗
                  </TrackedButton>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
}
